import React from 'react';

const ProjectCard = (props) => {
    const { i, project, onClick } = props;
    return (
        <li key={i}>
            <figure>
                <div className='card' onClick={() => onClick?.(project.id)}>
                    <img className='card-image' src={project.image} alt={project.title} />
                </div>
                <figcaption>
                    <div>{project.title} </div>
                    <span>{project.investor} </span>
                </figcaption>
            </figure>
        </li>
    )
}

export default ProjectCard;
